import { render, staticRenderFns } from "./NewContactAlert.vue?vue&type=template&id=4f30865e&scoped=true&"
import script from "./NewContactAlert.vue?vue&type=script&lang=js&"
export * from "./NewContactAlert.vue?vue&type=script&lang=js&"
import style0 from "./NewContactAlert.vue?vue&type=style&index=0&id=4f30865e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f30865e",
  null
  
)

export default component.exports